import { RejectedReasons } from './rejected-reasons';

export default RejectedReasons;
